import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { togetCurrentUser } from "../utils/APIs";
import ScreenLoader from "./ScreenLoader";

const PrivateRoute = ({ children, ToolStore }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  useEffect(() => {
    if (!ToolStore.user) {
      togetCurrentUser().then((res) => {
        ToolStore.setUser(res);
        setIsAuthenticated(res.email ?? "");
      });
    } else {
      setIsAuthenticated(ToolStore.user.email);
    }
  }, []);

  if (!isAuthenticated) return <ScreenLoader />;

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
